import {
    showCartErrorHtml,
    createCartBillingFormData,
    getPaypalOrderId
} from '../api';
import {
    addProductForPDPbtnFlow
} from './pdpHelper';
import {
    getPaypalButtonStyle
} from '../helper';
const { appendToUrl } = require('/cartridges/app_bc/cartridge/client/default/js/common/urlUtil');


var loaderInstance = require('../loader');
var $loaderContainer = document.querySelector('.paypalLoader');
var loader = loaderInstance($loaderContainer);
var pid;
var uuid;
var removeFromCartUrl;
// var base = require('../base');

function getAnalyticsAccessType() {
    var accessType;
    if ($('body:not(.cc-mobile)').length) {
        if ($(document.activeElement).parents('.js-sticky-add-to-cart').length) {
            accessType = 'pdp-sticky-bottom';
        } else {
            accessType = 'pdp';
        }
    } else if ($('.cc-pdp__info--top').length) {
        if ($('.cc-pdp__resume-mobile--fixed').length) {
            accessType = 'pdp-sticky-top-micro';
        } else {
            accessType = 'pdp-sticky-top-macro';
        }
    } else {
        accessType = 'pdp-sticky-bottom';
    }
    return accessType;
}

/**
 * Init button and disable it then upon size select decide if disable or enable
 *
 * @returns {boolean} success
 */
function onInit() {
    var actions = arguments[1];
    if (!$('#js-size-text-selected').hasClass('hidden')) {
        actions.enable();
    } else {
        actions.disable();
    }
    $('body').on('product:afterAttributeSelect', function (e) {
        if (!$('#js-size-text-selected').hasClass('hidden')) {
            actions.enable();
        }
    });
}

/**
 * Checks if a product variant is selected and opens the size selector otherwise.
 * Triggers analytics event.
 *
 * @returns {boolean} success
 */
function onClick() {
    var $btn = $(document).find('button.add-to-cart');
    var isStiky = $(document.activeElement).closest('.cc-content-addtocart-sticky').length > 0;
    var accessType = getAnalyticsAccessType(); // analytics access type

    // check if product variant is selected
    if ($btn.data('disabled')) {
        if ($('body').hasClass('cc-mobile') || isStiky) {
            $('#size-modal-sticky').data('analyticsowner', 'paypal');
            var $sizeBtn = $('.js-size-sticky:visible');
            if (! $sizeBtn.length) $sizeBtn = $('.js-size-sticky').eq(0);
            $sizeBtn.trigger('click', {accessType});
            $('#paypalButtonSizeNotSelected').val('true');
        } else {
            $('#size-overlay').data('analyticsowner', 'paypal');
            $('.js-size-modal').click();
            $('#paypalButtonSizeNotSelected').val('true');
        }
        return false;
    } else {
        dataLayer.push({
            event: 'custom_event',
            eventCategory: 'checkout',
            eventAction: 'fast',
            eventLabel: 'Paypal Express',
            accessType: accessType
        });
    }
}

/**
 *  Gets order id as string
 *
 * @returns {string} order id
 */
function createOrder() {
    loader.show();
    var res = addProductForPDPbtnFlow();
    
    if (res.cart) {
        uuid = res.pliUUID;
        removeFromCartUrl = res.cart.actionUrls.removeProductLineItemUrl;
        pid = res.pid;
    } else {
        loader.hide();
        throw new Error(res.message || 'Error occurs');
    }

    return getPaypalOrderId();
}

/**
 *  Makes post call and transfers order ID to returnFromCart endpoint, goes to checkout place order stage
 *
 * @param {Object} orderID - order id
 */
function onApprove({ orderID }) {
    // make sure that amount > 0
    var $defer = $.Deferred();
    $.get(window.paypalUrls.getCartPurchaseUnit)
        .then(function ({ purchase_units }) {
            let parsedPurchaseUnit = purchase_units[0];
            if (JSON.parse(parsedPurchaseUnit.amount.value) === 0) {
                showCartErrorHtml('Order total 0 is not allowed for PayPal');
                $defer.reject();
            } else {
                $defer.resolve();
            }
        })
        .fail(function(){
            $defer.reject();
        });


    let cartBillingFormData = createCartBillingFormData({
        paypalOrderID: orderID
    }, document.querySelector('.js_paypal_button_on_pdp_page'));

    $defer.done(function() {
        $.ajax({
            type: 'POST',
            url: window.paypalUrls.returnFromCart,
            contentType: false,
            data: cartBillingFormData,
            processData: false,
            success: () => {
                loader.hide();
                $.spinner().start();

                // validate shipping
                $.ajax({
                    type: 'GET',
                    url: window.paypalUrls.validateShipping,
                    success: (data) => {
                        if (data.error && data.countryMatchError) {
                            window.location.href = data.redirectUrl;
                        } else {
                            // validate billing
                            $.ajax({
                                type: 'GET',
                                url: window.paypalUrls.billingStep,
                                success: (data) => {
                                    var continueUrl = data.continueUrl;
                                    var urlParams = {
                                        ID: data.orderID,
                                        token: data.orderToken
                                    };
    
                                    continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?') +
                                        Object.keys(urlParams).map(function (key) {
                                            return key + '=' + encodeURIComponent(urlParams[key]);
                                        }).join('&');
                                    
                                    // redirect to TYP
                                    window.location.href = continueUrl;
                                },
                                error: (data) => {
                                    $.spinner().stop();
                                    // todo paypal: show billing error message
                                }
    
                            });
                        }
                    },
                    error: function(data) {
                        $.spinner().stop();
                        // todo paypal: show shipping error message
                    }
                });
            },
            error: function () {
                loader.hide();
                window.location.href = window.paypalUrls.cartPage;
            }
        });
    });
}

/**
 * Hides loader on paypal widget closing without errors
 * If PDP flow, removes product from basket on cancel
 */
function onCancel() {
    var urlParams = {
        pid: pid,
        uuid: uuid
    };

    $.ajax({
        url: appendToUrl(removeFromCartUrl, urlParams),
        type: 'get',
        dataType: 'json',
        success: function () {
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
    loader.hide();
}

/**
 * Shows errors if paypal widget was closed with errors
 * If PDP flow, removes product from basket on error
 */
function onError() {
    if (pid) {
        var productID = pid;
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        $.ajax({
            url: appendToUrl(removeFromCartUrl, urlParams),
            type: 'get',
            dataType: 'json',
            success: function () {
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
    loader.hide();
}

/**
 *Inits paypal button on cart page
 */
function initPaypalButton() {
    // if (!$(document).find('.js-4Gift-eneble').length > 0) {
    //     $('.cc-content-addtocart-sticky .cc-addtocart-buttons').addClass('cc-paypal-button-pdp');
        
    // } else {
    //     $(document).find('.cc-content-addtocart-sticky .cc-addtocart-buttons').addClass('cc-paypal-button-pdp');
    // }
    $(document).find('.cc-content-addtocart-sticky .cc-addtocart-buttons').addClass('cc-paypal-button-pdp');
    $(document).find('.cc-content-addtocart .cc-addtocart-buttons .add-to-cart').addClass('cc-custom-margin');
    $(document).find('.cc-content-addtocart .cc-addtocart-buttons .paypal_pdp_button ').addClass('cc-custom-margin');
    loader.show();
    $(document).find('.paypal-pdp-button').each(function () {
        window.paypal.Buttons({
            onInit,
            onClick,
            createOrder,
            onApprove,
            onCancel,
            onError,
            style: getPaypalButtonStyle(document.querySelector('.js_paypal_button_on_pdp_page'))
        }).render(this)
            .then(() => {
                loader.hide();
            });
    });
    $('body').on('product:afterAttributeSelectPayPal', function (e) {
        $('.paypal-button-label-container').click();
    });
}

export default initPaypalButton;
